// extracted by mini-css-extract-plugin
export default {"list":"NavigationLinks_list__eAWB+","link":"NavigationLinks_link__Wbwki","icon":"NavigationLinks_icon__BhSyr"};